import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={props.width? `calc( ${props.width}/ 369 * 367 )`: 367}
    viewBox="0 0 369 367"
    fill="none"
    {...props}
  >
    <g opacity={0.6}>
      <path
        stroke="#fff"
        d="m276.462 25.081 91.96 158.397-91.96 158.396H92.538L.578 183.478l91.96-158.397h183.924Z"
      />
      <path
        fill="#F1F1F1"
        d="m323.704 184.5-69.252 119.947H115.949L46.699 184.5l69.25-119.947h138.503L323.704 184.5Z"
      />
      <path
        fill="#E7E7E7"
        d="m240.376 280.071 55.708-96.083H73.253l55.708 96.083h111.415Z"
      />
      <path
        fill="#EAEAEA"
        d="m128.624 87.905-55.708 96.083h222.831l-55.708-96.083H128.624Z"
      />
    </g>
  </svg>
)
export default SvgComponent
